// --- HMAC utility ---
export async function generateGeoSignature(
  secret: string,
): Promise<{ timestamp: string; signature: string }> {
  const timestamp = Date.now().toString()
  const encoder = new TextEncoder()
  // Import the shared secret as a CryptoKey
  const key = await crypto.subtle.importKey(
    "raw",
    encoder.encode(secret),
    { name: "HMAC", hash: "SHA-256" },
    false,
    ["sign"],
  )
  // Sign the timestamp
  const sigBuffer = await crypto.subtle.sign(
    "HMAC",
    key,
    encoder.encode(timestamp),
  )
  // Convert ArrayBuffer to hex string
  const signature = Array.from(new Uint8Array(sigBuffer))
    .map(b => b.toString(16).padStart(2, "0"))
    .join("")
  return { timestamp, signature }
}
